import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Product, ProductChoiceGroup } from '../restaurant-manager.models';
import { ApiService } from './api.service';
import { RestaurantService } from './restaurant.service';

@Injectable({
    providedIn: 'root'
})
export class ProductService {

    constructor(private apiService: ApiService, private restaurantService: RestaurantService) { }

    getChoices(restaurantId: string): Observable<ProductChoiceGroup[]> {
        return this.apiService.get<ProductChoiceGroup[]>('/sync2/restaurants/' + restaurantId + '/choices', true).pipe(map((choices: any[]) => {
            return choices.map(c => new ProductChoiceGroup(c));
        }));
    }

    get(productId: string): Observable<Product> {
        return this.apiService.get<Product>('/products/' + productId, false).pipe(map((product) => {
            return new Product(product);
        }));
    }

}
